const filteredOptions = [
	{ value: 'All', label: 'All', color: '' },
	{ value: 'Prod', label: 'Prod', color: 'colorEnvProd' },
	{ value: 'PreProd', label: 'PreProd', color: 'colorEnvPreProd' },
	{ value: 'Dev', label: 'Dev', color: 'colorEnvDev' },
	{ value: 'Trash', label: 'Trash' },
];

export default filteredOptions;